import { authFetch } from "#app/utils/auth.client";
import {
  getWorkflowServiceContextHeaders,
  type WorkflowSvcContext,
} from "#app/utils/workflow-svc";

export const basePath = "/api/v1/projects";

export function workflowSvcUrl() {
  return ENV.WORKFLOW_SVC_PUBLIC_URL.replace(/\/$/, "");
}

export function ctxHeaders(ctx?: WorkflowSvcContext) {
  return getWorkflowServiceContextHeaders(ctx);
}

export { authFetch };
export type { WorkflowSvcContext };

export async function readError(
  response: Response,
  fallback: string,
): Promise<string> {
  const text = await response.text().catch(() => "");
  if (!text) return fallback;
  try {
    const json = JSON.parse(text) as { error?: string; details?: string };
    return json.error || json.details || fallback;
  } catch {
    return text;
  }
}

export type ProjectsPagination = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
};

export function threadsBase(projectId: string) {
  return `${workflowSvcUrl()}${basePath}/${encodeURIComponent(projectId)}/threads`;
}
